export default __webpack_public_path__ + "static/media/family.e4c56a92.svg";